// source for crawler user agents: https://udger.com/resources/ua-list/crawlers?c=1
const PATTERN_LIST = ['bingbot', 'googlebot', 'yahoo']

// This logic is extracted from here:
// https://github.com/omrilotan/isbot/blob/main/src/isbot/index.js#L66
export default function isCrawler(userAgent: string | undefined): boolean {
  const re = new RegExp(PATTERN_LIST.join('|'), 'i')
  return !!userAgent && re.test(userAgent)
}
